<template>
  <div>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="140px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="name" label="姓名：" >
                  <el-input size="small" v-model="form.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="signStatus" label="签到状态：">
                  <!-- <el-input size="small" v-model="form.signStatus"></el-input> -->
                  <el-select
                    ref="signStatus"
                    v-model="form.signStatus"
                    clearable
                  >
                    <el-option
                      v-for="item in signStatusList"
                      :key="item.value"
                      :label="item.title"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="signOutStatus" label="签退状态：">
                  <!-- <el-input
                    size="small"
                    v-model="form.signOutStatus"
                  ></el-input> -->
                  <el-select
                    ref="signOutStatus"
                    v-model="form.signOutStatus"
                    @visible-change="visibleChange"
                    clearable
                  >
                    <el-option
                      v-for="item in signOutStatusList"
                      :key="item.value"
                      :label="item.title"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="classCode" label="批次号/班级编码：">
                  <el-input size="small" v-model="form.classCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="signOpenTime" label="签到时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.signOpenTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    clearable
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="signEndTime" label="签退时间：">
                  <el-date-picker
                    size="small"
                    v-model="form.signEndTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    clearable
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button type="primary" @click="exportVideoDataList"
          >导出筛选结果</el-button
        >
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      @cell-mouse-enter="cellMouseeEnter"
      @cell-mouse-leave="cellMouseLeave"
      class="attendance_table"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        label="ID"
        width="50"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          {{ scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize }}
        </template>
      </el-table-column>
      <el-table-column
        prop="liveCourseName"
        label="课时名称"
        width="100"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="uname"
        label="姓名"
        width="50"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        :label="'手机号\n （账号）'"
        align="center"
        header-align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="classCode"
        :label="'批次号/\n 班级编码'"
        align="center"
        header-align="center"
        width="200"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="signStatus"
        label="签到状态"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="signCreateDate"
        label="签到时间"
        align="center"
        header-align="center"
      >
        <template #default="scope">
          {{ scope.row.signCreateDate | datetimeFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="signOutCreateDate"
        label="签到截止时间"
        align="center"
        header-align="center"
      >
        <template #default="scope">
          {{ scope.row.signintime | timeadd(0) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="signOutStatus"
        label="签退状态"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="signOutCreateDate"
        label="签退时间"
        align="center"
        header-align="center"
      >
        <template #default="scope">
          {{ scope.row.signOutCreateDate | datetimeFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="signOutCreateDate"
        label="签退截止时间"
        align="center"
        header-align="center"
      >
        <template #default="scope">
          {{ scope.row.signouttime | timeadd(0) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="star"
        label="评分情况"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="content"
        label="评分内容"
        align="center"
        header-align="center"
      ></el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/attendance/pc'
export default {
  props: ['curRowId'],
  data() {
    return {
      type: this.$route.query.type,
      activeNames: [],
      form: {
        name: '',
        signStatus: '',
        signOutStatus: '',
        classCode: '',
        signOpenTime: '',
        signEndTime: '',
      },
      selectedList: [],
      tableData: [],
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      signOutStatusList:[
        {value:'签退成功',title:'签退成功'},
        // {value:'签退失败',title:'签退失败'},
        {value:'未签退',title:'未签退'},
      ],
      signStatusList:[
        {value:'签到成功',title:'签到成功'},
        // {value:'签到失败',title:'签到失败'},
        {value:'未签到',title:'未签到'},
      ]
    }
  },
  created() {
    this.getList()
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  filters: {
    timeadd: function (value1, value2) {
      let newTime = parseInt(value1)
      // return new Date(parseInt(newTime) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ');
      function add0(m) {
        return m < 10 ? '0' + m : m
      }
      var time = new Date(newTime * 1000)
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      var h = time.getHours()
      var mm = time.getMinutes()
      var s = time.getSeconds()
      return (
        y +
        '-' +
        add0(m) +
        '-' +
        add0(d) +
        ' ' +
        add0(h) +
        ':' +
        add0(mm) +
        ':' +
        add0(s)
      )
    },
  },
  computed: {
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    async getList() {
      const {
        name,
        signStatus,
        signOutStatus,
        classCode,
        signOpenTime,
        signEndTime,
      } = this.form
      const [signOpenTimeMin, signOpenTimeMax] = signOpenTime
      const [signEndTimeMin, signEndTimeMax] = signEndTime

      const reqdata = {
        batchId: this.curRowId,
        type: this.type,
        name,
        signStatus,
        signOutStatus,
        classCode,
        signOpenTimeMin,
        signOpenTimeMax,
        signEndTimeMin,
        signEndTimeMax,
        ...this.pageObj,
      }
      const { code, data } = (await api.getSignList(reqdata)).data
      if (code === 100000) {
        this.tableData = data.list
        this.total = data.total
      }
    },
    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    //清空搜索内容
    delAll() {
      this.$refs.form.resetFields()
      this.pageObj.page = 1
      this.getList()
    },
    //搜索
    search() {
      this.pageObj.page = 1
      this.getList()
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    cellMouseeEnter(row, column, cell, event) {
      const colName = ['classCode']
      if (colName.includes(column.property)) {
        cell.style.color = 'rgb(64,158,255)'
      }
    },
    cellMouseLeave(row, column, cell, event) {
      const colName = ['classCode']
      if (colName.includes(column.property)) {
        cell.removeAttribute('style')
      }
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },
    visibleChange(e) {
      if (!e) {
        // this.$refs.testTypeList.blur()
        // this.$refs.testModeList.blur()
        this.$refs.signStatus.blur()
        this.$refs.signOutStatus.blur()
        // this.$refs.coursePropertiesList.blur()
      }
    },
    sortChange({ column, prop, order }) {
      console.log(order)
      if (order === 'ascending') {
      } else if (order === 'descending') {
      } else {
      }
    },
    exportVideoDataList() {
      console.log('链接',`${this.url}/zkfz/zkolSignRecord/exportVideoDataList?type=${this.type}&batchId=${this.curRowId}`)
      // return;
      window.open(
        `${this.url}/zkfz/zkolSignRecord/exportVideoDataList?type=${this.type}&batchId=${this.curRowId}`
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
.control {
  position: relative;
  .control_back {
    position: absolute;
    right: 10px;
  }
}
/deep/ .el-table th > .cell {
  white-space: pre-wrap;
}
/deep/.attendance_table {
  .el-table__header-wrapper {
    .el-table__header {
      tr > th:nth-child(6) {
        .cell {
          position: relative;
          .caret-wrapper {
            position: absolute;
            top: 8px;
          }
        }
      }
    }
  }
}
</style>